<template>
    <tr class="item">
        <td>
            <input type="hidden" :value="value.id" />
            <!-- <FormKit
                v-model="value.description"
                validation="required|length:0,250"
                @input="updateItem"
            /> -->
            <input
                name="Description"
                placeholder="Bijv. activiteitnaam"
                v-model="value.description"
                @input="updateItem"
                class="form-control"
            />
        </td>

        <td>
            <input :value="total" :key="total" disabled class="form-control" />
        </td>

        <td>
            <input
                :value="commissionTotal"
                :key="commissionTotal"
                disabled
                class="form-control"
            />
        </td>

    <td style="width: 40px;">
      <div class="d-flex">
          <button
              type="button"
              @click="removeItem"
              class="btn btn-danger btn-lg px-2 mr-2"
          ><i class="lar la-trash-alt"></i></button>
          <button
              type="button"
              @click="addItem"
              class="btn btn-primary btn-lg px-2"
          ><i class="las la-plus"></i></button>
      </div>
    </td>
  </tr>
  <tr>
    <td class="p-0" colspan="6">
      <InvoiceGroups :groups="item.groups" @add-group="addGroup" :key="item.groups.length" />
    </td>
  </tr>
</template>

<script setup>
import { computed, reactive } from "vue";
import InvoiceGroups from "./InvoiceGroups.vue";

const { item, index } = defineProps({
  item: {},
  index: {
    type: Number,
    default: 0,
  },
});

const value = reactive({ ...item });

const emit = defineEmits(["remove-item", "update-item", "add-item"]);

const addItem = () => {
    emit("add-item", index);
}

const updateItem = () => {
  emit("update-item", value);
};

const removeItem = () => {
    if (confirm("Regel verwijderen?")) {
        emit('remove-item', index)
    }
}

const addGroup = (index = null) => {
    if (index == null) {
        index = value.groups.length;
    } else {
        index += 1;
    }

    value.groups.splice(index, 0,{
        group: "",
        amount: 0,
        price: 0,
        commission_type: "fixed",
        commission: 0,
    });

  updateItem();
};

const commissionTotal = computed(() => {
  let commissionTotal = 0;

  for (let group of value.groups) {
    let total = group.amount * group.price;

    switch (group.commission_type) {
      case "percentage":
        commissionTotal += (total / 100) * group.commission;
        break;
      default:
        commissionTotal += group.amount * group.commission;
        break;
    }
  }

  return Number(commissionTotal).toFixed(2);
});

const total = computed(() =>
  value.groups
    .reduce((total, group) => total + group.amount * group.price, 0)
    .toFixed(2)
);
</script>
